"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Backend = void 0;
class Backend {
  async readIndex() {
    if (typeof window === 'undefined') {
      throw new Error('window not defined, make sure to load this script in the browser');
    }
    const indexData = window.localStorage.getItem(this.indexKey);
    if (indexData) {
      return JSON.parse(indexData);
    }
  }
  async writeIndex(index) {
    if (window) {
      // make a file from index including date in name
      const indexData = JSON.stringify(index);
      window.localStorage.setItem(this.indexKey, indexData);
    } else {
      throw new Error('window not defined, make sure to load this script in the browser');
    }
  }
  async uploadIndex() {
    const index = await this.readIndex();
    if (index) {
      const indexFile = new File([JSON.stringify(index || {})], `${Date.now()}.json`, {
        type: 'application/json'
      });
      return await this.upload(indexFile);
    }
  }
  async downloadIndex(url) {
    const indexFile = await (await fetch(url)).json();
    await this.writeIndex(indexFile);
  }
  resetIndex() {
    if (window) {
      window.localStorage.removeItem(this.indexKey);
    } else {
      throw new Error('window not defined, make sure to load this script in the browser');
    }
  }
}
exports.Backend = Backend;